import { render, staticRenderFns } from "./BWXMKCRO.vue?vue&type=template&id=8e26158c&scoped=true"
import script from "./BWXMKCRO.vue?vue&type=script&lang=js"
export * from "./BWXMKCRO.vue?vue&type=script&lang=js"
import style0 from "./BWXMKCRO.vue?vue&type=style&index=0&id=8e26158c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e26158c",
  null
  
)

export default component.exports